import { EVENTS } from 'common/domain/constants';
import { MODALS } from 'common/domain/constants';
import { STATES } from 'common/domain/states';
// import {MODULE_ID as FOOD_BENEFIT_MODULE_ID} from 'food-benefit.module/common/domain/constants';
import { MODULE_ID as VACATIONS_ABSENCES_MODULE_ID } from 'vacations-absences.module/common/domain/constants';
import Swipe from 'common/utils/swipe';

const STATES_MAIN_MENU = {
  CURRENT_STATE: 'current-state',
  STATE_ON_EVENT: 'state-on-event',
};

class MainMenuMobileController {
  constructor($state,
    $location,
    $window,
    $timeout,
    $scope,
    $rootScope,
    visitedPagesService,
    AuthenticationService,
    mainMenuMobileBehaviourService) {
    'ngInject';
    this.state = $state;
    this.location = $location;
    this.window = $window;
    this.timeout = $timeout;
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.visitedPagesService = visitedPagesService;
    this.authenticationService = AuthenticationService;
    this.mainMenuMobileBehaviourService = mainMenuMobileBehaviourService;
    this.isClosing = false;

    this.stateMainMenu = STATES_MAIN_MENU.CURRENT_STATE;
    this.isDev = process.env.isDev;
    this.version = process.env.version;
    this.isMobileApp = $window.innerWidth < 1024;
    this.render = this.shouldRender();
  }

  $onInit() {
    this.changeStateVacationsToMobile();
    this._setAvatarInfo();
    this._setRequestNumberOfEmployees();
    this.onChangeCurrentState();
    this.onChangeTitle();
    this.onChangeBadgeNumber();
  }

  $postLink() {
    this.run();
  }

  get overlay() {
    return angular.element(document.querySelector('main-menu-mobile .overlay'));
  }

  get html() {
    return angular.element(document.querySelector('html'));
  }

  get body() {
    return angular.element(document.querySelector('body'));
  }

  get button() {
    return angular.element(document.querySelector('main-menu-mobile .menu-toggle input'));
  }

  get movileNav() {
    return angular.element('#mobile-nav');
  }

  get inputMenuToggle() {
    return angular.element('#inputMenuToggle');
  }

  run() {
    this.initSwipe();
  }

  shouldRender() {
    return this.state.current.name !== STATES.VACATIONS_ABSENCES.EMPLOYEE_CALENDAR_MOBILE;
  }

  initSwipe() {
    const swiper = new Swipe('html');
    swiper.onLeft(event => this.onSwipeLeft(event));
    swiper.onRight(event => this.onSwipeRight(event));
    swiper.run();
  }

  onSwipeLeft(event) {
    if (this.avoidSwipe(event)) {
      return false;
    }

    if (!this.isMenuOpened()) {
      this.inputMenuToggle.click();
    }
  }

  onSwipeRight(event) {
    if (this.avoidSwipe(event)) {
      return false;
    }

    if (this.isMenuOpened()) {
      this.inputMenuToggle.click();
    }
  }

  avoidSwipe(event) {
    return $('main-menu-mobile').hasClass('focus-fixed') || $(event.target).closest('.swipe-container').length > 0;
  }

  onChangeCurrentState() {
    this.scope.$watch(() => this.state.current.name, newValue => {
      this.render = this.shouldRender();
      this.configure(newValue);
    });
  }

  _setAvatarInfo() {
    this.employee = {
      name: this.employeeInfo._profile.name,
      email: this.employeeInfo._profile.email,
      userId: this.employeeInfo._profile.userId,
      bbvaUserId: this.employeeInfo._profile.bbvaUserId
    };
  }

  _setRequestNumberOfEmployees() {
    //[AA TEAM REQUEST CODE]
    //if (this.module === FOOD_BENEFIT_MODULE_ID) this._setRequestNumberOfEmployeesFoodBenefit();
    if (this.module === VACATIONS_ABSENCES_MODULE_ID) this._setRequestNumberOfEmployeesVacationsAbsences();
  }

  //[AA TEAM REQUEST CODE]
  // _setRequestNumberOfEmployeesFoodBenefit() {
  //   const managerInfo = this.managerInfo;
  //   this.requestBadgeNumber = (managerInfo) ? managerInfo.employeesFoodBenefitPeriods.length : null;
  // }

  _setRequestNumberOfEmployeesVacationsAbsences() {
    const teamRequestInfo = this.managerInfo;
    this.requestBadgeNumber = (teamRequestInfo) ? teamRequestInfo.length : null;
  }

  isTeamRequestLink(link) {
    const TEAM_REQUEST_FOOD_BENEFIT = STATES.FOOD_BENEFIT.MANAGER;
    const TEAM_REQUEST_VACATIONS_ABSENCES = STATES.VACATIONS_ABSENCES.TEAM_REQUESTS;
    return (link.target === TEAM_REQUEST_FOOD_BENEFIT) || (link.target === TEAM_REQUEST_VACATIONS_ABSENCES);
  }

  isMenuOpened() {
    return this.menuOpened;
  }

  onChangeBadgeNumber() {
    this.rootScope.$on(EVENTS.BADGE_NUMBER, (event, data) => {
      this.requestBadgeNumber = data.badgeNumber;
    });
  }

  onChangeTitle() {
    this.rootScope.$on(EVENTS.CHANGE_TITLE, (event, data) => {
      this.titleLiteral = data.title;
      this.stateMainMenu = STATES_MAIN_MENU.STATE_ON_EVENT;
    });
  }

  configure(newValue) {
    const current = newValue;

    const link = this.links.find(link => {

      this.linkMatch = link.target === current;

      if (this.linkMatch) {
        this.fromMatch = false;
        this.altMatch = false;
      } else {
        this.fromMatch = link.fromStates.indexOf(newValue) > -1;
        this.altMatch = link.altStates.indexOf(newValue) > -1;
      }

      return this.linkMatch || this.fromMatch || this.altMatch;
    });

    if (this.stateMainMenu === STATES_MAIN_MENU.CURRENT_STATE) {
      this.titleLiteral = link.title;
    }

    this.stateMainMenu = STATES_MAIN_MENU.CURRENT_STATE;
  }

  showMenuButton() {
    return this.linkMatch;
  }

  showBackButton() {
    return this.fromMatch || this.altMatch;
  }

  onOverlayClick() {
    if (!this.isClosing) {
      this.closeMenu();
      this.hideOverlay();
    }
  }

  toggleOpen() {
    this.menuOpened = !this.menuOpened;
    this.menuOpened ? this.showOverlay() : this.hideOverlay();
  }

  closeMenu() {
    this.button.click();
    this.hideOverlay();
  }

  showOverlay() {
    this.html.addClass('mobile-overflow');
    this.body.addClass('mobile-overflow');
    this.overlay.addClass('fade-in');
    this.movileNav.removeClass('fade-out');
    this.menuOpened = true;
    this.isClosing = false;
    this.overlay.show();
  }

  hideOverlay() {
    this.html.removeClass('mobile-overflow');
    this.body.removeClass('mobile-overflow');
    this.movileNav.addClass('fade-out');
    this.overlay.removeClass('fade-in');
    this.menuOpened = false;
    this.isClosing = true;
    this.timeout(() => {
      if (this.menuOpened === false) {
        this.overlay.hide();
        this.isClosing = false;
      }
    }, 1000);
  }

  goBack() {
    if (this.mainMenuMobileBehaviourService.hasCustomBehaviour()) {
      try {
        this.mainMenuMobileBehaviourService.invoke();
      } catch (err) {
        this.visitedPagesService.subtractPageToCounter();
        this.window.history.back();
      }
      this.mainMenuMobileBehaviourService.clean();
    } else {
      this.visitedPagesService.subtractPageToCounter();
      const params = this.location.search() || {};
      delete params.from;
      this.location.search(params);
      this.window.history.back();
    }
  }

  getCssLink(link) {
    const query = this.location.search() || {};
    const from = query.from || '';
    return {
      'alt-active': (
        link.target === this.state.current.name ||
        link.altStates.includes(this.state.current.name) ||
        link.target.includes(from) ||
        link.fromStates.includes(from)
      ),
    };
  }

  goToChangeEmployee() {
    this.closeMenu();
    $(MODALS.DEV_CHANGE_EMPLOYEE_MOBILE).modal('show');
  }

  onLogout() {
    this.authenticationService.pluginLogout();
  }

  getCssVersion() {
    return {
      'warning': this.isDev,
    };

  }

  changeStateVacationsToMobile() {
    if (this.isMobileApp && this.state.current.name === STATES.VACATIONS_ABSENCES.MY_VACATIONS) {
      this.state.go(STATES.VACATIONS_ABSENCES.MY_VACATIONS_MOBILE, { dateToLoad: this.dateToLoad });
    }
  }
}

export default MainMenuMobileController;



// WEBPACK FOOTER //
// ./client/app/components/mainMenuMobile/mainMenuMobile.controller.js